export function tanquesfisicosInRequest(params = {}) {
  return {
    type: '@tanquesfisicos/TANQUESFISICOS_IN_REQUEST',
    payload: { params },
  };
}

export function findTanqueFisico(idtanquefisico) {
  return {
    type: '@tanquesfisicos/FIND_TANQUEFISICO',
    payload: { idtanquefisico },
  };
}

export function failedRequest() {
  return {
    type: '@tanquesfisicos/FAILED_REQUEST',
  };
}

export function deleteTanqueFisico(idtanquefisico, params) {
  return {
    type: '@tanquesfisicos/DELETE_TANQUEFISICO',
    payload: { idtanquefisico, params },
  };
}

export function updateTanqueFisico(tanquefisico, params) {
  return {
    type: '@tanquesfisicos/UPDATE_TANQUEFISICO',
    payload: { tanquefisico, params },
  };
}

export function storeTanqueFisico(tanquefisico, params) {
  return {
    type: '@tanquesfisicos/STORE_TANQUEFISICO',
    payload: { tanquefisico, params },
  };
}

export function successInRequest(
  tanquesfisicos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@tanquesfisicos/SUCCESS_IN_REQUEST',
    payload: { tanquesfisicos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(tanquefisico) {
  return {
    type: '@tanquesfisicos/SUCCESS_REQUEST',
    payload: { tanquefisico },
  };
}

export function successRemove(params) {
  return {
    type: '@tanquesfisicos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@tanquesfisicos/RECORD_FILTERING',
    payload: { params },
  };
}
